/* eslint camelcase: ["error", {allow: ["member_id", "form_id", "load_sections", "customdb_table_id", "is_default", "options_json", "form_options", "dispatch_usage", "dispatch_subline", "dispatch_default_name", "dispatch_message", "dispatch_show_map", "dispatch_predefined_form_tags", "fill_style"]}] */
/* global member_id */

import { createStore } from 'vuex'
import { fetchNest } from '@/components/mixins/HttpRequests.vue'
import StoreFunctions from '@/components/mixins/StoreFunctions.vue'

export const store = createStore({
  state: {
    relatedMembers: [],
    memberOptions: [],
    customdbTables: [],
    customdbTablesColumns: {},
    customdbGroups: [],
    customdbItems: [],
    dispatchFormItems: {},
    forms: [],
    formsEdit: [],
    formsOptions: [],
    files: {},
    myLocation: {
      lat: null,
      lng: null,
      source: null
    },
    translations: {},
    translationsMobile: {},
    brands: [],
    currencies: [],
    paymentPlans: [],
    fillSettings: {
      allowFinishAndNew: true
    },
    csrfTokens: {},
    members: [],
    loadedData: [],
    memberGroups: [],
    languages: [],
    mobileLanguages: [],
    websocket: null,
    websocketConnected: false,
    websocketControllerRegistered: false,
    websocketReconnectTries: 5,
    progress: [],
    hintHandleCurrent: ''
  },
  mutations: {
    setRelatedMembers (state, relatedMembers) {
      state.relatedMembers = relatedMembers
    },
    addRelatedMembers (state, relatedMembers) {
      relatedMembers.forEach(relatedMember => {
        const index = state.relatedMembers.findIndex(member => member.member_id === relatedMember.member_id)
        if (index > -1) {
          state.relatedMembers[index].relations.push(relatedMember.relations[0])
        } else {
          state.relatedMembers.push(relatedMember)
        }
      })
    },
    setMemberOptions (state, memberOptions) {
      state.memberOptions = memberOptions
    },
    addMemberOptions (state, memberOptions) {
      state.memberOptions = state.memberOptions.concat(memberOptions)
    },
    updateMemberOptions (state, memberOption) {
      const index = state.memberOptions.findIndex(options => options.member_option_id === memberOption.member_option_id)
      if (index > -1) {
        state.memberOptions.splice(index, 1, memberOption)
      } else {
        state.memberOptions.push(memberOption)
      }
    },
    removeMemberOption (state, memberOption) {
      const index = state.memberOptions.findIndex(options => options.member_option_id === memberOption.member_option_id)
      if (index > -1) {
        state.memberOptions.splice(index, 1)
      }
    },
    unsetMemberOptionsDefaultByHandle (state, handle) {
      const index = state.memberOptions.findIndex(options => options.handle === handle && options.is_default === 1)
      if (index > -1) {
        state.memberOptions[index].is_default = 0
      }
    },
    setCustomdbTables (state, customdbTables) {
      state.customdbTables = customdbTables
    },
    addCustomdbTable (state, customdbTable) {
      state.customdbTables.push(customdbTable)
    },
    updateCustomdbTable (state, customdbTable) {
      const index = state.customdbTables.findIndex(table => table.customdb_table_id === customdbTable.customdb_table_id)
      if (index > -1) {
        state.customdbTables.splice(index, 1, Object.assign(state.customdbTables[index], customdbTable))
      } else {
        state.customdbTables.push(customdbTable)
      }
    },
    removeCustomdbTable (state, customdbTable) {
      const index = state.customdbTables.findIndex(table => table.customdb_table_id === customdbTable.customdb_table_id)
      if (index > -1) {
        state.customdbTables.splice(index, 1)
      }
    },
    updateCustomdbTableSubline (state, { customdbTableId, dispatchSubline }) {
      const index = state.customdbTables.findIndex(table => table.customdb_table_id === customdbTableId)
      if (!state.customdbTables[index].options_json) {
        state.customdbTables[index].options_json = []
      }
      state.customdbTables[index].options_json.dispatch_subline = dispatchSubline
    },
    updateCustomdbTableDispatchMessage (state, { customdbTableId, dispatchMessage }) {
      const index = state.customdbTables.findIndex(table => table.customdb_table_id === customdbTableId)
      if (!state.customdbTables[index].options_json) {
        state.customdbTables[index].options_json = []
      }
      state.customdbTables[index].options_json.dispatch_message = dispatchMessage
    },
    updateCustomdbTableDispatchUsage (state, { customdbTableId, dispatchUsage }) {
      const index = state.customdbTables.findIndex(table => table.customdb_table_id === customdbTableId)
      state.customdbTables[index].dispatch_usage = dispatchUsage
    },
    setCustomdbTablesColumns (state, columnsForTables) {
      state.customdbTablesColumns = columnsForTables
    },
    addCustomdbTablesColumns (state, { tableId, columnsForTable }) {
      state.customdbTablesColumns[tableId] = columnsForTable
    },
    removeCustomdbTableColumns (state, customdbTableId) {
      delete state.customdbTablesColumns[customdbTableId]
    },
    setDispatchFormItemsFromForms (state, dispatchForms) {
      dispatchForms.forEach(form => {
        state.dispatchFormItems[form.form_id] = StoreFunctions.methods.getDispatchFormItems(form)
      })
    },
    addDispatchFormItems (state, { formId, dispatchFormItems }) {
      state.dispatchFormItems[formId] = dispatchFormItems
    },
    removeDispatchFormItems (state, formId) {
      delete state.dispatchFormItems[formId]
    },
    setForms (state, forms) {
      state.forms = forms
    },
    addForms (state, forms) {
      forms.forEach(form => {
        const index = state.forms.findIndex(formStored => formStored.form_id === form.form_id)
        if (index > -1) {
          state.forms.splice(index, 1, Object.assign({}, state.forms[index], form))
        } else {
          state.forms.push(form)
        }
      })
    },
    addForm (state, form) {
      const index = state.forms.findIndex(formStored => formStored.form_id === form.form_id)
      if (index > -1) {
        state.forms.splice(index, 1, Object.assign({}, state.forms[index], form))
      } else {
        state.forms.push(form)
      }
    },
    addFormsEdit (state, forms) {
      forms.forEach(form => {
        const index = state.formsEdit.findIndex(formStored => formStored.form_id === form.form_id)
        if (index > -1) {
          state.formsEdit.splice(index, 1, Object.assign({}, state.formsEdit[index], form))
        } else {
          state.formsEdit.push(form)
        }
      })
    },
    addFormsOptions (state, formsOptions) {
      formsOptions.forEach(formOption => {
        const index = state.formsOptions.findIndex(formOptionStored => formOptionStored.form_option_id === formOption.form_option_id)
        if (index > -1) {
          state.formsOptions.splice(index, 1, Object.assign({}, state.formsOptions[index], formOption))
        } else {
          state.formsOptions.push(formOption)
        }
      })
    },
    changeResponseFillStylesForm (state, { formId, fillStyles }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      state.forms[index].form_options.fill_style = fillStyles
    },
    addFile (state, file) {
      state.files[file.file_id] = file
    },
    removeFile (state, fileId) {
      delete state.files[fileId]
    },
    setMyLocation (state, myLocation) {
      state.myLocation = myLocation
    },
    addTranslations (state, translations) {
      state.translations = Object.assign({}, state.translations, translations)
    },
    removeTranslation (state, handleString) {
      delete state.translations[handleString]
    },
    addTranslationsMobile (state, translations) {
      state.translationsMobile = Object.assign({}, state.translationsMobile, translations)
    },
    removeTranslationMobile (state, handleString) {
      delete state.translationsMobile[handleString]
    },
    addCustomdbItems (state, cdbItems) {
      const currentIds = {}
      state.customdbItems.forEach((currentItem, index) => {
        currentIds[currentItem.customdb_item_id] = index
      })
      cdbItems.forEach(cdbItem => {
        const index = typeof currentIds[cdbItem.customdb_item_id] !== 'undefined' ? currentIds[cdbItem.customdb_item_id] : -1
        if (index > -1) {
          state.customdbItems.splice(index, 1, cdbItem)
        } else {
          state.customdbItems.push(cdbItem)
        }
      })
    },
    addCustomdbGroup (state, cdbGroup) {
      const index = state.customdbGroups.findIndex(cdbItemStored => cdbItemStored.customdb_group_id === cdbGroup.customdb_group_id)
      if (index > -1) {
        state.customdbGroups.splice(index, 1, cdbGroup)
      } else {
        state.customdbGroups.push(cdbGroup)
      }
    },
    updateFormSubline (state, { formId, dispatchSubline }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      if (!state.forms[index].form_options) {
        state.forms[index].form_options = []
      }
      state.forms[index].form_options.dispatch_subline = dispatchSubline
    },
    updateFormDispatchName (state, { formId, dispatchName }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      if (!state.forms[index].form_options) {
        state.forms[index].form_options = []
      }
      state.forms[index].form_options.dispatch_default_name = dispatchName
    },
    updateFormDispatchMessage (state, { formId, dispatchMessage }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      if (!state.forms[index].form_options) {
        state.forms[index].form_options = []
      }
      state.forms[index].form_options.dispatch_message = dispatchMessage
    },
    updateFormDispatchShowMap (state, { formId, dispatchShowMap }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      if (!state.forms[index].form_options) {
        state.forms[index].form_options = []
      }
      state.forms[index].form_options.dispatch_show_map = dispatchShowMap
    },
    updateFormPredefinedDispatchTags (state, { formId, formDispatchPredefinedTags }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      if (!state.forms[index].form_options) {
        state.forms[index].form_options = []
      }
      state.forms[index].form_options.dispatch_predefined_form_tags = formDispatchPredefinedTags
    },
    updateFormDispatchUsage (state, { formId, dispatchUsage }) {
      const index = state.forms.findIndex(form => form.form_id === formId)
      state.forms[index].dispatch_usage = dispatchUsage
    },
    addBrands (state, brands) {
      brands.forEach(brand => {
        const index = state.brands.findIndex(brandStored => brandStored.brand_id === brand.brand_id)
        if (index > -1) {
          state.brands.splice(index, 1, Object.assign({}, state.brands[index], brand))
        } else {
          state.brands.push(brand)
        }
      })
    },
    setCurrencies (state, currencies) {
      state.currencies = currencies
    },
    setPaymentPlans (state, paymentPlans) {
      state.paymentPlans = paymentPlans
    },
    addFillSettings (state, fillSettings) {
      state.fillSettings = Object.assign({}, state.fillSettings, fillSettings)
    },
    addCsrfTokens (state, csrfTokens) {
      state.csrfTokens = Object.assign({}, state.csrfTokens, csrfTokens)
    },
    addMember (state, member) {
      const index = state.members.findIndex(memberStored => memberStored.member_id === member.member_id)
      if (index === -1) {
        state.members.push(member)
      }
    },
    updateMember (state, member) {
      const index = state.members.findIndex(memberStored => memberStored.member_id === member.member_id)
      if (index > -1) {
        state.members.splice(index, 1, Object.assign({}, state.members[index], member))
      } else {
        state.members.push(member)
      }
    },
    addMemberExceptions (state, { memberId, exceptions }) {
      const index = state.members.findIndex(member => member.member_id === memberId)
      if (!state.members[index].exceptions) {
        state.members[index].exceptions = exceptions
      } else {
        state.members[index].exceptions = Object.assign({}, state.members[index].exceptions, exceptions)
      }
    },
    setMemberDispatchPermissions (state, { memberId, dispatchPermissions }) {
      const index = state.members.findIndex(member => member.member_id === memberId)
      state.members[index].dispatchPermissions = dispatchPermissions
    },
    addLoadedData (state, loadedData) {
      if (!state.loadedData.includes(loadedData)) {
        state.loadedData.push(loadedData)
      }
    },
    addMemberGroups (state, memberGroups) {
      memberGroups.forEach(memberGroup => {
        const index = state.memberGroups.findIndex(memberGroupStored => memberGroupStored.group_id === memberGroup.group_id)
        if (index > -1) {
          state.memberGroups.splice(index, 1, memberGroup)
        } else {
          state.memberGroups.push(memberGroup)
        }
      })
    },
    setLanguages (state, languages) {
      state.languages = languages
    },
    setMobileLanguages (state, mobileLanguages) {
      state.mobileLanguages = mobileLanguages
    },
    setWebSocket (state, websocket) {
      state.websocket = websocket
    },
    setWebsocketConnected (state, websocketConnected) {
      state.websocketConnected = websocketConnected
    },
    setWebsocketControllerRegistered (state, websocketControllerRegistered) {
      state.websocketControllerRegistered = websocketControllerRegistered
    },
    setWebsocketReconnectTries (state, websocketReconnectTries) {
      state.websocketReconnectTries = websocketReconnectTries
    },
    setProgress (state, progress) {
      state.progress[progress.progress_id] = progress
    },
    setHintHandleCurrent (state, hintHandle) {
      state.hintHandleCurrent = hintHandle
    }
  },
  actions: {
    setRelatedMembers ({ commit }, relatedMembers) {
      commit('setRelatedMembers', relatedMembers)
    },
    addRelatedMembers ({ commit }, relatedMembers) {
      commit('addRelatedMembers', relatedMembers)
    },
    setMemberOptions ({ commit }, memberOptions) {
      commit('setMemberOptions', memberOptions)
    },
    addMemberOptions ({ commit }, memberOptions) {
      commit('addMemberOptions', memberOptions)
    },
    updateMemberOptions ({ commit }, memberOption) {
      commit('updateMemberOptions', memberOption)
    },
    removeMemberOption ({ commit }, memberOption) {
      commit('removeMemberOption', memberOption)
    },
    unsetMemberOptionsDefaultByHandle ({ commit }, handle) {
      commit('unsetMemberOptionsDefaultByHandle', handle)
    },
    setCustomdbTables ({ commit }, customdbTables) {
      commit('setCustomdbTables', customdbTables)
    },
    addCustomdbTable ({ commit }, customdbTable) {
      commit('addCustomdbTable', customdbTable)
    },
    updateCustomdbTable ({ commit }, customdbTable) {
      commit('updateCustomdbTable', customdbTable)
    },
    removeCustomdbTable ({ commit }, customdbTable) {
      commit('removeCustomdbTable', customdbTable)
    },
    updateCustomdbTableSubline ({ commit }, { customdbTableId, dispatchSubline }) {
      commit('updateCustomdbTableSubline', { customdbTableId, dispatchSubline })
    },
    updateCustomdbTableDispatchMessage ({ commit }, { customdbTableId, dispatchMessage }) {
      commit('updateCustomdbTableDispatchMessage', { customdbTableId, dispatchMessage })
    },
    updateCustomdbTableDispatchUsage ({ commit }, { customdbTableId, dispatchUsage }) {
      commit('updateCustomdbTableDispatchUsage', { customdbTableId, dispatchUsage })
    },
    setCustomdbTablesColumns ({ commit }, columnsForTables) {
      commit('setCustomdbTablesColumns', columnsForTables)
    },
    addCustomdbTablesColumns ({ commit }, { tableId, columnsForTable }) {
      commit('addCustomdbTablesColumns', { tableId, columnsForTable })
    },
    removeCustomdbTableColumns ({ commit }, customdbTableId) {
      commit('removeCustomdbTableColumns', customdbTableId)
    },
    setDispatchFormItemsFromForms ({ commit }, dispatchForms) {
      commit('setDispatchFormItemsFromForms', dispatchForms)
    },
    addDispatchFormItems ({ commit }, { formId, dispatchFormItems }) {
      commit('addDispatchFormItems', { formId, dispatchFormItems })
    },
    removeDispatchFormItems ({ commit }, formId) {
      commit('removeDispatchFormItems', [formId])
    },
    setForms ({ commit }, forms) {
      commit('setForms', forms)
    },
    addForms ({ commit }, forms) {
      commit('addForms', forms)
    },
    addForm ({ commit }, form) {
      commit('addForm', form)
    },
    addFormsEdit ({ commit }, forms) {
      commit('addFormsEdit', forms)
    },
    addFormsOptions ({ commit }, formsOptions) {
      commit('addFormsOptions', formsOptions)
    },
    changeResponseFillStylesForm ({ commit }, formId, fillStyles) {
      commit('changeResponseFillStylesForm', formId, fillStyles)
    },
    addFiles ({ commit }, files) {
      files.forEach(file => {
        commit('addFile', file)
      })
    },
    addFile ({ commit }, file) {
      commit('addFile', file)
    },
    removeFile ({ commit }, fileId) {
      commit('removeFile', fileId)
    },
    setMyLocation ({ commit }, myLocation) {
      commit('setMyLocation', myLocation)
    },
    addTranslations ({ commit }, translations) {
      commit('addTranslations', translations)
    },
    removeTranslation ({ commit }, handleString) {
      commit('removeTranslation', handleString)
    },
    addTranslationsMobile ({ commit }, translationsMobile) {
      commit('addTranslationsMobile', translationsMobile)
    },
    removeTranslationMobile ({ commit }, handleString) {
      commit('removeTranslationMobile', handleString)
    },
    addCustomdbItems ({ commit }, cdbItems) {
      commit('addCustomdbItems', cdbItems)
    },
    addCustomdbGroups ({ commit }, cdbGroups) {
      cdbGroups.forEach(cdbGroup => {
        commit('addCustomdbGroup', cdbGroup)
      })
    },
    updateFormSubline ({ commit }, { formId, dispatchSubline }) {
      commit('updateFormSubline', { formId, dispatchSubline })
    },
    updateFormDispatchName ({ commit }, { formId, dispatchName }) {
      commit('updateFormDispatchName', { formId, dispatchName })
    },
    updateFormDispatchMessage ({ commit }, { formId, dispatchMessage }) {
      commit('updateFormDispatchMessage', { formId, dispatchMessage })
    },
    updateFormDispatchShowMap ({ commit }, { formId, dispatchShowMap }) {
      commit('updateFormDispatchShowMap', { formId, dispatchShowMap })
    },
    updateFormPredefinedDispatchTags ({ commit }, { formId, formDispatchPredefinedTags }) {
      commit('updateFormPredefinedDispatchTags', { formId, formDispatchPredefinedTags })
    },
    updateFormDispatchUsage ({ commit }, { formId, dispatchUsage }) {
      commit('updateFormDispatchUsage', { formId, dispatchUsage })
    },
    addBrands ({ commit }, brands) {
      commit('addBrands', brands)
    },
    setCurrencies ({ commit }, currencies) {
      commit('setCurrencies', currencies)
    },
    setPaymentPlans ({ commit }, paymentPlans) {
      commit('setPaymentPlans', paymentPlans)
    },
    addFillSettings ({ commit }, fillSettings) {
      commit('addFillSettings', fillSettings)
    },
    addCsrfTokens ({ commit }, csrfTokens) {
      commit('addCsrfTokens', csrfTokens)
    },
    addMember ({ commit }, member) {
      commit('addMember', member)
    },
    updateMember ({ commit }, member) {
      commit('updateMember', member)
    },
    addMemberExceptions ({ commit }, { memberId, exceptions }) {
      commit('addMemberExceptions', { memberId, exceptions })
    },
    setMemberDispatchPermissions ({ commit }, { memberId, dispatchPermissions }) {
      commit('setMemberDispatchPermissions', { memberId, dispatchPermissions })
    },
    addLoadedData ({ commit }, loadedData) {
      commit('addLoadedData', loadedData)
    },
    addMemberGroups ({ commit }, memberGroups) {
      commit('addMemberGroups', memberGroups)
    },
    setLanguages ({ commit }, languages) {
      commit('setLanguages', languages)
    },
    setMobileLanguages ({ commit }, mobileLanguages) {
      commit('setMobileLanguages', mobileLanguages)
    },
    setWebSocket ({ commit }, websocket) {
      commit('setWebSocket', websocket)
    },
    setWebsocketConnected ({ commit }, websocketConnected) {
      commit('setWebsocketConnected', websocketConnected)
    },
    setWebsocketControllerRegistered ({ commit }, websocketControllerRegistered) {
      commit('setWebsocketControllerRegistered', websocketControllerRegistered)
    },
    setWebsocketReconnectTries ({ commit }, setWebsocketReconnectTries) {
      commit('setWebsocketReconnectTries', setWebsocketReconnectTries)
    },
    setProgress ({ commit }, progress) {
      commit('setProgress', progress)
    },
    setHintHandleCurrent ({ commit }, hintHandle) {
      commit('setHintHandleCurrent', hintHandle)
    }
  },
  getters: {
    relatedMembers: state => state.relatedMembers,
    relatedMemberById: state => id => state.relatedMembers.find((member) => parseInt(member.member_id) === parseInt(id)),
    relatedMembersByGroupId: state => groupId => {
      return state.relatedMembers.filter(member => {
        for (const relation of member.relations) {
          if (groupId in relation.member_groups) {
            return true
          }
        }
        return false
      })
    },
    relatedMembersByMemberId: state => id => state.relatedMembers.filter((member) => member.relations && member.relations.some((relation) => parseInt(relation.member_id) === parseInt(id || member_id))),
    memberOptions: state => state.memberOptions,
    memberOptionsByHandle: state => handle => state.memberOptions.filter((options) => options.handle === handle),
    memberOptionsByHandleAndMemberId: state => (handle, memberId) => state.memberOptions.filter((options) => options.handle === handle && options.member_id === memberId),
    memberOptionById: state => id => state.memberOptions.find((memberOption) => parseInt(memberOption.member_option_id) === parseInt(id)),
    customdbTables: state => state.customdbTables,
    customdbTableById: state => tableId => state.customdbTables.find((table) => parseInt(table.customdb_table_id) === parseInt(tableId)),
    customdbTableByColumnId: state => columnId => state.customdbTables.find((table) => table.customdb_columns.some((column) => parseInt(column.customdb_column_id) === parseInt(columnId))),
    customdbTablesColumnsByTableId: state => tableId => {
      return new Promise((resolve, reject) => {
        if (!tableId) {
          return resolve(null)
        }
        if (state.customdbTablesColumns[tableId]) {
          return resolve(state.customdbTablesColumns[tableId])
        }
        fetchNest('site/ajax.php?act=customdb_search_get_columns', { customdb_table_id: tableId }, undefined, undefined, 'get', undefined, true, 0, true, store)
          .then(response => {
            if (response !== null) {
              store.dispatch('addCustomdbTablesColumns', { tableId, columnsForTable: response[tableId] })
              return resolve(response[tableId])
            }
            reject(new Error('Invalid response'))
          }).catch((reason) => { reject(reason) })
      })
    },
    customdbTablesColumnsByTableIdAndColumnId: state => (tableId, columnId) => {
      if (state.customdbTablesColumns[tableId]) {
        const customdbTable = state.customdbTablesColumns[tableId].find(column => column.customdb_column_id === columnId)
        if (customdbTable) {
          return customdbTable
        }
      }
      return null
    },
    dispatchFormItemsByFormId: state => (formId, includeCustomdbFormItems) => {
      return new Promise((resolve, reject) => {
        if (!formId) {
          return resolve(null)
        }
        if (state.dispatchFormItems[formId]) {
          return resolve(includeCustomdbFormItems ? state.dispatchFormItems[formId] : state.dispatchFormItems[formId].filter(formItem => formItem.options_json.dispatch_display > 0))
        }
        fetchNest('api/v2/forms/' + formId, undefined, undefined, undefined, 'get', undefined, true, 0, true, store)
          .then(response => {
            if (response !== null) {
              const dispatchFormItems = StoreFunctions.methods.getDispatchFormItems(response.items[0])
              store.dispatch('addDispatchFormItems', { formId, dispatchFormItems })
              return resolve(includeCustomdbFormItems ? dispatchFormItems : dispatchFormItems.filter(formItem => formItem.options_json.dispatch_display > 0))
            }
            reject(new Error('Invalid response'))
          }).catch((reason) => { reject(reason) })
      })
    },
    dispatchFormItemByFormIdAndFormItemId: state => (formId, formItemId) => {
      if (state.dispatchFormItems[formId]) {
        const form = state.dispatchFormItems[formId].find(formItem => formItem.form_item_id === formItemId)
        if (form) {
          return form
        }
      }
      return null
    },
    forms: state => state.forms,
    formById: state => formId => state.forms.find((form) => form.form_id === parseInt(formId)),
    formsByCustomdb: state => customdbId => state.forms.filter((form) => form.customdb_tables && form.customdb_tables.some((tableId) => tableId === parseInt(customdbId))),
    formsEdit: state => state.formsEdit,
    formsOptions: state => state.formsOptions,
    formsOptionsByHandle: state => handle => state.formsOptions.filter(item => item.handle === handle),
    files: state => state.files,
    fileById: state => fileId => state.files[fileId] ? state.files[fileId] : null,
    filesByIds: state => fileIds => fileIds ? fileIds.map(fileId => state.files[fileId]) : [],
    filesByMemberIdAndHandle: state => (memberId, handle) => {
      const files = []
      for (const fileId in state.files) {
        if (Object.hasOwnProperty.call(state.files, fileId) && state.files[fileId].member_id === memberId && state.files[fileId].handle === handle) {
          files.push(state.files[fileId])
        }
      }
      return files
    },
    myLocation: state => state.myLocation,
    translations: state => state.translations,
    translationByHandleString: state => handleString => {
      if (state.translations[handleString]) {
        return state.translations[handleString]
      } else if (Object.keys(state.translations).length > 0) {
        if (['superuser', 'developer'].includes(window.member_role)) {
          console.error('Unknown handle string: ', handleString)
        }
        const pageBase = window.location.pathname.replace(/\?(.*)$/, '').replace(/^((.*)\/)?([^/]+)/, '$3')
        window.gaEvent('vueTranslationMissing', handleString, pageBase)
      }
      return handleString
    },
    translationMobileByHandleString: state => handleString => state.translationsMobile[handleString] ? state.translationsMobile[handleString] : handleString,
    cdbItemsByColumnId: state => customdbColumnId => state.customdbItems.filter((customdbItem) => customdbItem.customdb_column_id === customdbColumnId),
    cdbItemByColumnIdAndGroupId: state => (columnId, groupId) => state.customdbItems.find((customdbItem) => customdbItem.customdb_column_id === columnId && customdbItem.customdb_group_id === groupId),
    cdbItemsByColumnIdAndParentGroupId: state => (columnId, parentGroupId) => {
      const out = state.customdbItems.filter((customdbItem) => {
        const myGroups = state.customdbGroups.filter(group => {
          return group.parent_id === parentGroupId
        }).map(item => item.customdb_group_id)
        return customdbItem.customdb_column_id === columnId && myGroups.includes(customdbItem.customdb_group_id)
      })
      return out
    },
    cdbItemByColumnIdAndValue: state => (columnId, value) => state.customdbItems.find((customdbItem) => customdbItem.customdb_column_id === columnId && customdbItem.value === value),
    cdbGroupByGroupId: state => groupId => state.customdbGroups.find(cdbGroup => cdbGroup.customdb_group_id === groupId),
    cdbColumnByColumnId: state => columnId => {
      for (const customdbTable of state.customdbTables) {
        const cdbColumn = customdbTable.customdb_columns.find((cdbColumn) => parseInt(cdbColumn.customdb_column_id) === parseInt(columnId))
        if (cdbColumn) {
          return cdbColumn
        }
      }
      return null
    },
    brands: state => state.brands,
    brandById: state => brandId => state.brands.find((brand) => brand.brand_id === parseInt(brandId)),
    brandsByMemberId: state => memberId => state.brands.filter((brand) => brand.member_id === memberId),
    currencyById: state => currencyId => state.currencies.find((currency) => currency.currency_id === parseInt(currencyId)),
    paymentPlans: state => state.paymentPlans,
    paymentPlanById: state => paymentPlanId => state.paymentPlans.find((paymentPlan) => paymentPlan.payment_plan_id === parseInt(paymentPlanId)),
    fillSettings: state => state.fillSettings,
    csrfTokenByName: state => tokenName => state.csrfTokens[tokenName] ? state.csrfTokens[tokenName] : null,
    memberById: state => memberId => state.members.find((member) => member.member_id === parseInt(memberId)),
    loadedData: state => state.loadedData,
    memberGroupsByMemberId: state => memberId => state.memberGroups.filter((group) => group.member_id === memberId),
    languages: state => state.languages,
    mobileLanguages: state => state.mobileLanguages,
    websocket: state => state.websocket,
    websocketConnected: state => state.websocketConnected,
    websocketControllerRegistered: state => state.websocketControllerRegistered,
    websocketReconnectTries: state => state.websocketReconnectTries,
    progressByProgressId: state => progressId => state.progress[progressId],
    hintHandleCurrent: state => state.hintHandleCurrent
  }
})
